import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iPopupDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Popup/Popup';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const OrderLockTimerPopupBackAndSaveButtonId = 'OrderLockTimerPopup.BackButtonAndSave';
const OrderLockTimerPopupBackAndSaveButtonOptions: iButtonDisplayOptions & {
    id: string;
} = {
    id: OrderLockTimerPopupBackAndSaveButtonId,
    validationGroup: 'none',
    text: 't~OrderLockTimerPopup:info.back',
    width: '100%',
    type: 'success',
    stylingMode: 'text',
};
propsStore.insert(OrderLockTimerPopupBackAndSaveButtonOptions);

export const OrderLockTimerPopupBackButtonId = 'OrderLockTimerPopup.BackButton';
const OrderLockTimerPopupBackButtonOptions: iButtonDisplayOptions & {
    id: string;
} = {
    id: OrderLockTimerPopupBackButtonId,
    text: 't~OrderLockTimerPopup:expired.back',
    type: 'success',
    stylingMode: 'text',
};
propsStore.insert(OrderLockTimerPopupBackButtonOptions);

export const OrderLockTimerPopupContinueButtonId = 'OrderLockTimerPopup.ContinueButton';
const OrderLockTimerPopupContinueButtonOptions: iButtonDisplayOptions & {
    id: string;
} = {
    id: OrderLockTimerPopupContinueButtonId,
    validationGroup: 'none',
    text: 't~OrderLockTimerPopup:info.continue',
    width: '100%',
    type: 'success',
    stylingMode: 'contained',
};
propsStore.insert(OrderLockTimerPopupContinueButtonOptions);

export const OrderLockTimerPopupId = 'OrderLockTimerPopup.Popup';
const OrderLockTimerPopupOptions: iPopupDisplayOptions = {
    id: OrderLockTimerPopupId,
    dragEnabled: false,
    closeOnOutsideClick: false,
    showCloseButton: false,
    height: 'auto',
    width: '429px',
    showTitle: false,
};
propsStore.insert(OrderLockTimerPopupOptions);
